import React, { Component } from "react";
import { Modal, Icon } from "antd-mobile";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Theme from "../../utils/Theme";
import "./index.css";

const StyledContainer = styled.div`
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledContent = styled.div`
  height: auto;
  overflow: scroll;
  color: #888;
  text-align: center;
  font-size: 15px;
  padding: 15px;
`;

const StyledCancelButton = styled.div`
  cursor: pointer;
  width: 50%;
  &:hover {
    opacity: 0.5;
  }
  &:active {
    background: #dadada;
    color: #000;
    opacity: 1;
  }
  border-radius: 2px;
  color: #000;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledYesButton = styled.div`
  cursor: pointer;
  width: 50%;
  &:hover {
    opacity: 0.5;
  }
  &:active {
    background: #dadada;
    opacity: 1;
  }
  border-radius: 2px;
  color: #108ee9;
  border-left: 1px solid #ddd;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledDescription = styled.span`
  padding: 10px 0px;
  font-size: 18px;
`;

const StyledImage = styled.img`
  width: 80%;
  max-width: 100px;
  position: relative;
`;

const StyledButtonContainer = styled.div`
  width: 100%;
  height: 50px;
  position: relative;
  border-top: 1px solid #ddd;
  display: flex;
  text-align: center;
  font-size: 18px;
`;

class IsFoodOnlyModal extends Component {
  onIsFoodOnlyModalClose = () => {
    const { onIsFoodOnlyModalClose } = this.props;
    onIsFoodOnlyModalClose();
  };

  onCheckoutFromCart = () => {
    const { onCheckoutFromCart } = this.props;
    onCheckoutFromCart();
  };

  render() {
    const { shouldShow, onTouchStart } = this.props;

    return (
      <Modal
        className={"isfoodonly"}
        visible={shouldShow}
        transparent
        maskClosable={false}
        wrapProps={{ onTouchStart: onTouchStart }}
      >
        <StyledContainer>
          <StyledDescription>
            <FormattedMessage
              id="isfoodonly.title"
              defaultMessage="Reminder"
              description="title"
            />
          </StyledDescription>
          <StyledImage
            src={require("../../assets/icons/reminder_drinks.png")}
          />
          <StyledContent>
            <FormattedMessage
              id="isfoodonly.content"
              defaultMessage="You Have Not Order Drinks Yet"
              description="content message"
            />
          </StyledContent>
          <StyledButtonContainer>
            <StyledCancelButton onClick={this.onIsFoodOnlyModalClose}>
              <FormattedMessage
                id="isfoodonly.no"
                defaultMessage="No"
                description="No to close modal"
              />
            </StyledCancelButton>
            <StyledYesButton onClick={this.onCheckoutFromCart}>
              <FormattedMessage
                id="isfoodonly.yes"
                defaultMessage="Ok"
                description="Yes to proceed button"
              />
            </StyledYesButton>
          </StyledButtonContainer>
        </StyledContainer>
      </Modal>
    );
  }
}

IsFoodOnlyModal.propTypes = {
  shouldShow: PropTypes.bool.isRequired,
  onTouchStart: PropTypes.func.isRequired,
  onIsFoodOnlyModalClose: PropTypes.func.isRequired,
  onCheckoutFromCart: PropTypes.func.isRequired
};

IsFoodOnlyModal.defaultProps = {
  shouldShow: false
};

export default IsFoodOnlyModal;



// WEBPACK FOOTER //
// ./src/components/IsFoodOnlyModal/index.js